import React, {Fragment} from "react";
import {ConnectedReduxProps} from "@reducers/index";
import {Subscription} from "@models/subscription";
import DiscountPolicyForm from "@components/discountCodePolicy/Form";
import {injectIntl} from "react-intl";
import api from "@api/discount-code-policy";



interface PropsFromState {
  loading: boolean;
  data: Subscription[];
  errors?: string;
  count: number;
}

interface PropsFromDispatch {
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch & ConnectedReduxProps;

class FormPage extends React.Component<AllProps> {
  state = {
    discountCodePolicy: null,
    id: this.props.match.params.id,
    is_fetched: false
  };
  
  componentDidMount() {
    if (this.state.id) {
      this.fetchItem();
    }
  }
  
  fetchItem = () => {
    api
      .getItem({
        params: {
          id: this.state.id,
        }
      })
      .then(({data}) => {
        this.setState({
          discountCodePolicy: data
        });
      })
      .catch(error => {
      });
  };
  
  updateRequest = ({payload, params, onSuccessCallback, onErrorCallback, id}) => {
    api.update({
        payload,
        params:{
          id : params.id
        },
      })
      .then((data) => onSuccessCallback(data))
      .catch(error => onErrorCallback(error))
  };
  
  createRequest = ({payload, onSuccessCallback, onErrorCallback}) => {
    api.create({
        payload,
      })
      .then((data) => onSuccessCallback(data))
      .catch(error => onErrorCallback(error))
  };
  
  getContent = () => {
    if (!this.state.discountCodePolicy && this.state.id) {
      return null;
    }
    const viewOnly = this.state.discountCodePolicy
                    && new Date(this.state.discountCodePolicy.valid_from) < new Date()
                    ? true
                    : false
    
    return (
      <DiscountPolicyForm
        discountCodePolicy={this.state.discountCodePolicy}
        intl={this.props.intl}
        viewOnly={viewOnly}
        id={this.state.id}
        listUrl={"/discount-code-policies"}
        history={this.props.history}
        updateRequest={this.updateRequest}
        createRequest={this.createRequest}
      />
    );
  };
  
  render() {
    return <Fragment>{this.getContent()}</Fragment>;
  }
}


export default injectIntl(FormPage)
